import { Injectable } from "@angular/core";
import { ProcurementPurchaseOrdersService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { PurchaseOrdersPort } from "../../../app/ports/procurement/purchase-orders.port";
import { PurchaseOrder, PurchaseOrderPage, PurchaseOrderPageRequest, PurchaseOrderRequest, PurchaseOrderType, PurchaseOrderUpdateRequest } from "../../../domain/models/procurement/purchase-order.model";
import { mapPurchaseOrder, mapPurchaseOrderPage, mapPurchaseOrderPageRequest, mapPurchaseOrderRequest, mapPurchaseOrderType, mapPurchaseOrderUpdateRequest } from "../../mappers/procurement/purchase-order.mapper";

@Injectable({ providedIn: "root" })

export class PurchaseOrdersPortAdapter implements PurchaseOrdersPort {
  constructor(private readonly api: ProcurementPurchaseOrdersService) {}
  listTypes(active = true): Observable<readonly PurchaseOrderType[]> {
    return this.api.listTypes(active).pipe(map(({ data }) => data.map(mapPurchaseOrderType)));
  }

  getType(id: number): Observable<PurchaseOrderType> {
    return this.api.getType(id).pipe(map(({ data }) => mapPurchaseOrderType(data)));
  }

  getTypeByCode(code: string): Observable<PurchaseOrderType> {
    return this.api.getTypeByCode(code).pipe(map(({ data }) => mapPurchaseOrderType(data)));
  }

  list(request: PurchaseOrderPageRequest): Observable<PurchaseOrderPage> {
    return this.api.list(mapPurchaseOrderPageRequest(request)).pipe(map(({ data }) => mapPurchaseOrderPage(data)));
  }

  listAll(): Observable<readonly PurchaseOrder[]> {
    return this.api.listAll().pipe(map(({ data }) => data.map(mapPurchaseOrder)));
  }

  get(id: number): Observable<PurchaseOrder> {
    return this.api.get(id).pipe(map(({ data }) => mapPurchaseOrder(data)));
  }

  getByCode(code: string): Observable<PurchaseOrder> {
    return this.api.getByCode(code).pipe(map(({ data }) => mapPurchaseOrder(data)));
  }

  create(request: PurchaseOrderRequest): Observable<PurchaseOrder> {
    return this.api.create(mapPurchaseOrderRequest(request)).pipe(map(({ data }) => mapPurchaseOrder(data)));
  }

  update(id: number, request: PurchaseOrderUpdateRequest): Observable<PurchaseOrder> {
    return this.api.update(id, mapPurchaseOrderUpdateRequest(request)).pipe(map(({ data }) => mapPurchaseOrder(data)));
  }

  changeStatus(id: number, statusId: number): Observable<PurchaseOrder> {
    return this.api.changeStatus(id, statusId).pipe(map(({ data }) => mapPurchaseOrder(data)));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }
}
